<tm-menubar-button [component]="componentType"
                   [panelTitle]="panelTitle$ | async"
                   [tooltip]="panelTitle$ | async"
                   [icon]="(icon$ | async) ?? ''"></tm-menubar-button>
